import { Grid, Button, TextField, IconButton } from "@material-ui/core";
import { Add, Close } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import { IOrderLocation } from "../state/venueAreas.reducer";
import { useStyles } from "./styles";

interface IOrderLocations {
    orderLocations:IOrderLocation[];
    onChangeHandler:(e:React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,locationId:string)=>void;
    onDeleteHandler:(locationId:string)=>void;
    onCreateHandler:()=>void;
    disabled?: boolean;
    error?:string[]
}

enum FormKeys {
    LocationPublicName = "name_public",
    LocationPrivateName = "name_private"
}


export function OrderLocations(props: IOrderLocations) {
    const {  onChangeHandler, onDeleteHandler, onCreateHandler, orderLocations } = props;
    const { t } = useTranslation();
    const classes = useStyles();
   
    return <Grid container spacing={1}>
        {orderLocations.map((location:IOrderLocation) => <Grid container xs={12} spacing={2}  style={{marginBottom:"10px"}} key={location.id} >
            <Grid item xs={6} >
                <TextField
                    variant={'outlined'}
                    label={t("forms.settings.venueAreaLocationPublic")}
                    fullWidth
                    name={FormKeys.LocationPublicName}
                    onBlur = {(e) => onChangeHandler(e,location.id)}
                    type="text"
                    defaultValue={location?.name_public}
                    InputLabelProps={{ required: true }}
                    className={(location.id && (props?.error?.includes(location.id))) ? classes.locationError : ""}
                />
            </Grid>
            {/* <Grid item xs={5}>
                <TextField
                    variant={'outlined'}
                    label={t("forms.settings.venueAreaLocationPrivate")}
                    fullWidth
                    name={FormKeys.LocationPrivateName}
                    onBlur= {(e) => onChangeHandler(e,location.id)}
                    type="text"
                    defaultValue={location?.name_private}
                />
            </Grid> */}
            <Grid item xs={1}>
                    <IconButton className={classes.closeBtn} onClick={() => onDeleteHandler(location.id)} aria-label="delete" color="secondary"  data-component-name={`order-location-delete-button-${location.group_id}`}>
                        <Close style={{color:"#AAB6D3"}} />
                    </IconButton>
            </Grid>
        </Grid>)}
        < Grid item xs={12}>
            <Button data-component-name={"order-locations-extender-button"} onClick={onCreateHandler}  variant="outlined" style={{ color: "#212121", borderColor: "#C1CAE1!important" }}
            className={classes.addLocationBtn}
            > <Add style={{ paddingRight: "0.625rem", fontSize: "2rem" }} /> {t("merchant.buttons.newLocation")}</Button>
        </Grid>
    </Grid >
}